const mainSlider = document.querySelector('.main-slider');
if (mainSlider) {
    new Flickity(mainSlider, {
        // options
        cellAlign: 'left',
        contain: true,
        autoPlay: 8000,
        pauseAutoPlayOnHover: false
    });
}
const initHeadingAnimation = () => {
    const container = document.querySelector('[data-gsap]');
    if (container) {
        //@ts-ignore - Timeline GSAP
        const timeline = gsap.timeline();
        const elementsToAnimate = [
            '.title-gsap',
            '.subtitle-gsap',
            '.description-gsap',
            '.block-gsap',
            '.cta-button-gsap'
        ];
        elementsToAnimate.forEach((selector) => {
            const element = container.querySelector(selector);
            if (element) {
                // Animate timeline GSAP
                timeline.from(element, { opacity: 0, y: getElementOffsetY(selector), duration: 0.5 });
            }
        });
    }
};
function getElementOffsetY(selector) {
    // Adjust the y offset based on the selector if needed
    if (selector === '.title-gsap') {
        return -50;
    }
    else if (selector === '.subtitle-gsap') {
        return -50;
    }
    else if (selector === '.description-gsap') {
        return -30;
    }
    else if (selector === '.block-gsap') {
        return -20;
    }
    else if (selector === '.cta-button-gsap') {
        return 20;
    }
    return 0; // Default offset
}
